import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "album-list no-gutters row row-eq-height",
  style: {"cursor":"pointer"}
}
const _hoisted_2 = { class: "col-4 col-md-2" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "operator mt-3 text-center"
}
const _hoisted_5 = { class: "col-8 col-md-10 card-body pl-2 pt-0 pb-0" }
const _hoisted_6 = { class: "album-title" }
const _hoisted_7 = { class: "artist-title" }
const _hoisted_8 = { class: "style-list mt-0" }
const _hoisted_9 = { class: "album-year" }
const _hoisted_10 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_StyleTag = _resolveComponent("StyleTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "card-img",
        src: _ctx.album.primary_img,
        alt: _ctx.album.title
      }, null, 8, _hoisted_3),
      (_ctx.buttonText!='none')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.handleSelect
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.buttonText), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          target: "_blank",
          to: { path: '/meta/artist/'+_ctx.album.main_artist._id },
          class: "artist-name"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.album.main_artist.name), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_router_link, {
          target: "_blank",
          to: { path: '/meta/album/'+_ctx.album._id },
          class: "album-name"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.album.title), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", _hoisted_9, "[ " + _toDisplayString(_ctx.album.year) + " ]", 1),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stylesInShow, (style) => {
          return (_openBlock(), _createBlock(_component_StyleTag, {
            key: style._id,
            genre: style,
            full: 0
          }, null, 8, ["genre"]))
        }), 128)),
        (_ctx.album.styles && _ctx.album.styles.length>4)
          ? (_openBlock(), _createElementBlock("span", _hoisted_10, "..."))
          : _createCommentVNode("", true),
        (_ctx.album.type)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(["badge", {'badge-success':_ctx.album.type.index===1,'badge-primary':_ctx.album.type.index===3}])
            }, _toDisplayString(_ctx.album.type.name) + " / " + _toDisplayString(_ctx.album.album_type.name), 3))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}